// extracted by mini-css-extract-plugin
export default {"container":"CommunityHeader_container__Em800","text":"CommunityHeader_text__xOqzq"};